/**
 * d16n::legacy
 * d16n::source:<PProductDetailBlockToxicity.vue>
 * d16n::domain-file
 */

interface Toxicity {
  id: string
  name: string
}

export function hasPicto(toxicity: Toxicity) {
  return toxicity.id.startsWith('SGH')
}
